{
  "pages": {
    "services": {
      "title": "Services",
      "yourServices": "Your services",
      "otherServices": "Other available"
    }
  }
}
